import { KindResultDecisionCodesEnum } from 'APIPackage/CatalogsModule/enums/KindResultDecisionCodesEnum';
import { IDecision } from 'APIPackage/DecisionModule/interfaces/IDecision';
import { fetchDecisionById } from 'APIPackage/DecisionModule/services/decisionApi';
import { IDecisionListItem } from 'DecisionListPackage/MainModule/interfaces/IDecisionListItem';
import { parseDate } from 'CorePackage/MainModule/common/formatDate';
import { DATE_FORMAT_LONG_FNS } from 'CorePackage/MainModule/constants/dateFormats';
import { ROUTE_DECISION } from 'CorePackage/MainModule/routes/routes';

import { getMatchedViolation } from '../../../functions/getMatchedViolation';
import {
  convertDecisionOrganizationToSubject,
  convertErknmOrganizationsFromLink,
  convertErknmRequirementsFromLink,
  convertEventsFromLink,
  convertObjectsFromLink,
} from './convertLinkedData';
import { ILinkedPassportData, TLinkValidationResult } from './validateSelectedLinkKnm';

const DecisionNoSignedPrescriptionText = 'В паспорте отсутствует подписанное предписание';

const DecisionNoUnresolvedViolationsText =
  'Выбранный паспорт не содержит нарушений в статусах «Не устранено» или «Ожидает подтверждения», срок устранения которых уже наступил';

export interface IValidateSelectedLinkDecisionParams {
  decision: IDecisionListItem;
  isPm: boolean;
  erknmStartDateString?: string;
}

export const validateSelectedLinkDecision = async ({
  decision,
  isPm,
  erknmStartDateString,
}: IValidateSelectedLinkDecisionParams): Promise<TLinkValidationResult> => {
  const linkedDecision: IDecision = await fetchDecisionById(decision.id);
  const resultDecisions = linkedDecision.organization?.decisions ?? [];

  const hasSignedPrescription = resultDecisions.some(
    resultDecision => resultDecision.kind?.code === KindResultDecisionCodesEnum.D_7 && resultDecision.signed === true,
  );

  if (!hasSignedPrescription) {
    return DecisionNoSignedPrescriptionText;
  }

  const erknmStartDate = parseDate({
    date: erknmStartDateString || new Date(),
    parseFormat: DATE_FORMAT_LONG_FNS,
  });

  const violations = getMatchedViolation(resultDecisions, `${ROUTE_DECISION(decision.id)}`, erknmStartDate);

  if (!violations.length) {
    return DecisionNoUnresolvedViolationsText;
  }

  const decisionOrganization = linkedDecision.organization;
  const decisionObjects = linkedDecision.objects;

  if (!decisionOrganization || !decisionObjects) {
    return DecisionNoUnresolvedViolationsText;
  }

  const result: ILinkedPassportData = {
    organizations: convertErknmOrganizationsFromLink(convertDecisionOrganizationToSubject(decisionOrganization)),
    objects: convertObjectsFromLink(decisionObjects),
    events: isPm ? null : convertEventsFromLink(linkedDecision.events),
    requirements: isPm ? null : convertErknmRequirementsFromLink(violations),
  };

  return result;
};
